import * as React from 'react';
import moment from 'moment';
import styled from 'styled-components';

import { theme } from 'components';
import { replaceTagsWithMarkup } from 'utils';
import { PropertyAnnouncementType } from './types';

interface OfferMessageDetailProps {
  propertyAnnouncement: PropertyAnnouncementType;
}

const MESSAGE_SENT_TO = {
  all: 'All Agents',
  completedAppointmentsOnly: 'Completed Showings Only',
  registered: 'Registered Offers',
  upcomingAppointments: 'Upcoming Showings',
};

const OfferMessageDetail = (props: OfferMessageDetailProps) => {
  const {
    propertyAnnouncement: { body, createdAt, sentTo, sentBy, subject },
  } = props;

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="offer-message-detail-header">
          <div className="sent-to">
            <strong>Message Sent To: </strong>
            {MESSAGE_SENT_TO[sentTo]}
          </div>
          <div className="sent-date">
            <strong>Sent: </strong>
            {moment(createdAt).format('MMM D, YYYY hh:mm:ss A')}
          </div>
          <div className="sent-by">
            <strong>Sent By {`${sentBy.firstName} ${sentBy.lastName}`}</strong>
          </div>
        </div>
        <div className="offer-message-detail-subject">
          <h2>{subject}</h2>
        </div>
        <BodyContainer className="offer-message-detail-body">
          <div
            dangerouslySetInnerHTML={{ __html: replaceTagsWithMarkup(body) }}
          ></div>
        </BodyContainer>
      </div>
    </div>
  );
};

export default OfferMessageDetail;

const BodyContainer = styled.div`
  .template-tag {
    padding: 1px 4px;
    margin: 0px;

    color: ${theme.geekblue6};
    font-size: 12px;
    line-height: 20px;

    background-color: ${theme.geekblue1};
    opacity: 0.85;

    border: 1px solid ${theme.geekblue3};
    border-radius: 4px;
  }
  ul,
  ol {
    display: block;
    list-style: disc outside none;
    margin: 1em 0;
    padding: 0 0 0 40px;
  }
  ol {
    list-style-type: decimal;
  }
  li {
    display: list-item;
  }
  ul ul,
  ol ul {
    list-style-type: circle;
    margin-left: 15px;
  }
  ol ol,
  ul ol {
    list-style-type: lower-latin;
    margin-left: 15px;
  }
`;
